import React, { createContext, useReducer } from "react"
import PropTypes from "prop-types"
import DynamicElementsReducer, { initialState } from "./DynamicElementsReducer"

const DynamicElementsContext = createContext()

export default DynamicElementsContext

export const DynamicElementsProvider = ({ children }) => {
  const [state, dispatch] = useReducer(DynamicElementsReducer, initialState)

  return (
    <DynamicElementsContext.Provider value={{ state, dispatch }}>
      {children}
    </DynamicElementsContext.Provider>
  )
}

DynamicElementsProvider.propTypes = {
  children: PropTypes.node.isRequired,
}
